/**
 * "Press" — media/press page. Original copy. Provides a media contact and
 * brand-in-brief; intentionally does not invent press coverage or releases.
 */
export default function PressPage() {
  return (
    <div className="bg-cream text-ink">
      <section className="mx-auto max-w-4xl px-6 py-20 text-center sm:py-28">
        <p className="font-semibold uppercase tracking-[0.2em] text-clay">Press</p>
        <h1 className="mt-4 font-serif text-4xl font-semibold leading-tight sm:text-5xl">
          Newsroom
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-ink/70">
          Resources for journalists, editors, and partners writing about
          BestAcco and the independent hotels we feature.
        </p>
      </section>

      <section className="mx-auto max-w-3xl px-6 pb-24 text-[17px] leading-relaxed text-ink/80 [&_h2]:mt-14 [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:text-ink [&_p]:mt-4">
        <h2>Media inquiries</h2>
        <p>
          For interviews, comment, imagery requests, or anything else, please
          reach our press contact. We aim to respond to media requests promptly,
          and we are happy to connect you with the independent hoteliers in our
          collection where relevant.
        </p>
        <p>
          <strong>Press contact:</strong> Prateek Juneja<br />
          <a
            href="mailto:prateek.juneja@bestacco.com?subject=Press%20inquiry"
            className="text-clay underline"
          >
            prateek.juneja@bestacco.com
          </a>
        </p>

        <h2>BestAcco in brief</h2>
        <p>
          BestAcco is a curated platform for discovering and booking distinctive,
          independently owned hotels. We give travelers a calmer way to find
          places worth choosing on purpose, and we give independent properties a
          polished storefront and a direct route to guests. BestAcco is operated
          by BestAcco LLC, based in Kentucky, USA.
        </p>

        <h2>Brand assets</h2>
        <p>
          Need our logo, a brand description, or approved imagery for a story?
          Email the press contact above with details of your publication and
          deadline, and we will send the appropriate assets and usage guidance.
          Please use the BestAcco name and logo only in line with that guidance.
        </p>

        <h2>Announcements</h2>
        <p>
          Company news and announcements will be shared here as they are released.
          To be added to our press list for future updates, drop us a note at the
          address above.
        </p>
      </section>
    </div>
  );
}
